import { RedoIcon } from './RedoIcon';

/**
 * author: Google
 * id 7061BAB7-4413-4666-A919-9DD8C4F405F9
 * name redo
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/redo.svg
 * tags
 */
export const ArrowIcon = RedoIcon;
export default ArrowIcon